import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_ALL_DELIVERY_NOTES,
  FETCH_DELIVERY_NOTE_DETAILS,
  CREATE_DELIVERY_NOTE,
  UPDATE_DELIVERY_NOTE,
  DELETE_DELIVERY_NOTE,
} from "../constants";
import {
  fetchAllDeliveryNotesSuccess,
  fetchAllDeliveryNotesFailure,
  fetchDeliveryNoteDetailsSuccess,
  fetchDeliveryNoteDetailsFailure,
  createDeliveryNoteSuccess,
  createDeliveryNoteFailure,
  updateDeliveryNoteSuccess,
  updateDeliveryNoteFailure,
  deleteDeliveryNoteSuccess,
  deleteDeliveryNoteFailure,
} from "../actions";
import axios from "axios";
import { message } from "antd";

// API calls
const fetchDeliveryNotesAPI = (payload) => {
  const { project_id, page, perPage, search, sort, order } = payload;
  
  // Build params object with base parameters
  const params = {
    projectId: project_id,
    page,
    perPage,
    orderBy: sort,
    orderDirection: order,
  };
  
  // Add search parameters directly to params if they exist
  if (search) {
    Object.keys(search).forEach(key => {
      if (search[key] && search[key].trim() !== '') {
        params[key] = search[key];
      }
    });
  }
  
  return axios.get("/delivery-notes", { params });
};

const fetchDeliveryNoteDetailsAPI = (payload) => {
  const { id, project_id } = payload;
  return axios.get(`/delivery-notes/${id}`, {
    params: { project_id }
  });
};

const createDeliveryNoteAPI = (payload) => {
  // Ensure project_id is included in the payload
  return axios.post("/api/delivery-notes", payload);
};

const updateDeliveryNoteAPI = (payload) => {
  // Ensure project_id is included in the payload
  return axios.patch(`/delivery-notes/${payload.id}`, payload);
};

const deleteDeliveryNoteAPI = (payload) => {
  return axios.delete(`/api/delivery-notes/${payload.id}`, {
    params: { project_id: payload.project_id }
  });
};

// Saga workers
function* fetchAllDeliveryNotesSaga(action) {
  try {
    const response = yield call(fetchDeliveryNotesAPI, action.payload);
    yield put(fetchAllDeliveryNotesSuccess(response.data));
  } catch (error) {
    yield put(fetchAllDeliveryNotesFailure(error.message));
    message.error("Failed to fetch delivery notes");
  }
}

function* fetchDeliveryNoteDetailsSaga(action) {
  try {
    const response = yield call(fetchDeliveryNoteDetailsAPI, action.payload);
    yield put(fetchDeliveryNoteDetailsSuccess(response.data));
  } catch (error) {
    yield put(fetchDeliveryNoteDetailsFailure(error.message));
    message.error("Failed to fetch delivery note details");
  }
}

function* createDeliveryNoteSaga(action) {
  try {
    const response = yield call(createDeliveryNoteAPI, action.payload);
    yield put(createDeliveryNoteSuccess(response.data));
    message.success("Delivery note created successfully");
  } catch (error) {
    yield put(createDeliveryNoteFailure(error.message));
    message.error("Failed to create delivery note");
  }
}

function* updateDeliveryNoteSaga(action) {
  try {
    const response = yield call(updateDeliveryNoteAPI, action.payload);
    yield put(updateDeliveryNoteSuccess(response.data));
    message.success("Delivery note updated successfully");
  } catch (error) {
    yield put(updateDeliveryNoteFailure(error.message));
    message.error("Failed to update delivery note");
  }
}

function* deleteDeliveryNoteSaga(action) {
  try {
    yield call(deleteDeliveryNoteAPI, action.payload);
    yield put(deleteDeliveryNoteSuccess(action.payload));
    message.success("Delivery note deleted successfully");
  } catch (error) {
    yield put(deleteDeliveryNoteFailure(error.message));
    message.error("Failed to delete delivery note");
  }
}

// Watcher saga
export default function* deliveryNotesSaga() {
  yield takeLatest(FETCH_ALL_DELIVERY_NOTES, fetchAllDeliveryNotesSaga);
  yield takeLatest(FETCH_DELIVERY_NOTE_DETAILS, fetchDeliveryNoteDetailsSaga);
  yield takeLatest(CREATE_DELIVERY_NOTE, createDeliveryNoteSaga);
  yield takeLatest(UPDATE_DELIVERY_NOTE, updateDeliveryNoteSaga);
  yield takeLatest(DELETE_DELIVERY_NOTE, deleteDeliveryNoteSaga);
}
